import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private messageService: MessageService, private zone: NgZone) {}

  handleError(error: any): void {
    // Fehlerbehandlung in Angular Zone ausführen, damit UI-Updates erlaubt sind -> Wird eigentlich schon im ErrorInterceptor gemacht
    /*this.zone.run(() => {
      this.messageService.add({severity: 'error', summary: 'Fehler', detail: error?.message || 'Es ist ein Fehler aufgetreten.'});
    });*/

    // Optional: Fehler loggen
    //console.error('Unerwarteter Fehler:', error);
    // Optional: Weiterwerfen, um im DevMode den Stacktrace in Console zu sehen
    // throw error;
  }
}